import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    lede: {
        color: '#5a5a6a',
        marginTop: 4,
        marginBottom: 24,
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: 16,
    },
    value: {
        padding: 20,
        border: '1px solid #e8e8ed',
        borderRadius: 12,
        background: '#fafafc',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    num: {
        fontSize: 10,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        color: '#9a9aaa',
        fontWeight: 500,
    },
    text: {
        color: '#5a5a6a',
        lineHeight: 1.55,
    },
}));
